import { Text } from '@origin-digital/ods-core';
import React from 'react';
import { AlertContainer } from './AlertContainer';

interface RetryUsernameBannerProps {
  isVisible: boolean;
  usernameSubmitted: string;
}

export const RetryUsernameBanner: React.FC<RetryUsernameBannerProps> = ({
  isVisible,
  usernameSubmitted = '',
}) => {
  const isEmail = /@/.test(usernameSubmitted);
  const message = `Oops, that ${
    isEmail ? 'email' : 'number'
  } doesn't look right. Please double-check your ${
    isEmail ? 'email address' : 'mobile number'
  } or try your ${isEmail ? 'mobile number' : 'email address'} instead.`;
  return isVisible ? (
    <AlertContainer tone="critical" data-id="alert-retry-username-attempts">
      <Text>{message}</Text>
    </AlertContainer>
  ) : null;
};
